import React, {useState} from 'react';
import PageHeader1 from '../../components/common/PageHeader1';
import ActiveStatus from "../../components/Form/activeStatus";
import {useNavigate} from "react-router-dom";
import apiClient from "../../utils/api";

function BrandAdd() {
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        name: '', is_active: "1",
    });

    const handleInputChange = (e) => {
        const {name, type, value, checked} = e.target;
        setFormData({...formData, [name]: type === 'checkbox' ? checked : value});
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append('name', formData.name);
        data.append('is_active', formData.is_active);

        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.post('accounts/brands', data, {
                headers: { Authorization: `Bearer ${token}` }
            });
            navigate(process.env.PUBLIC_URL + '/accounts/brands-list',{
                headers: { Authorization: `Bearer ${token}` }
            });
        } catch (error) {
            console.error('Error:', error);
            navigate(process.env.PUBLIC_URL + '/accounts/brands-list');
        }
    }

    return (<div className="container-xxl">
        <form onSubmit={onSubmit}>
            <PageHeader1 pagetitle='Brand Add' button={true}/>
            <div className="row g-3">
                <div className="col-xl-4 col-lg-4">
                    <div className="sticky-lg-top">
                        <div className="card mb-3">
                            <ActiveStatus
                                onStatusChange={handleInputChange}
                                checked={formData.is_active}
                                name="is_active"
                            />
                        </div>
                    </div>
                </div>
                <div className="col-xl-8 col-lg-8">
                    <div className="card mb-3">
                        <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                            <h6 className="mb-0 fw-bold ">Basic information</h6>
                        </div>
                        <div className="card-body">
                            <form>
                                <div className="row g-3 align-items-center">
                                    <div className="col-md-12">
                                        <label className="form-label">Brand Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>)
}

export default BrandAdd;